import AppStore from './app';

const appStore = new AppStore();

export {AppStore, appStore};